import { Pill } from "../../components/Pill";
import { MATCH_STATUS_UI, TRUTH_SOURCE_UI } from "../../lib/enumUI";
import type { CrossCheckResult } from "../types";

export function ValidationPanel({ results }: { results: CrossCheckResult[] }) {
  if (results.length === 0) {
    return (
      <section>
        <h2>Cross-check results</h2>
        <p className="empty-state">
          No cross-check results recorded for this project.
        </p>
      </section>
    );
  }

  return (
    <section>
      <h2>Cross-check results</h2>
      <table className="data-table">
        <thead>
          <tr>
            <th>Rule</th>
            <th>Status</th>
            <th>Truth source (left)</th>
            <th>Evidence source (right)</th>
            <th>Left value</th>
            <th>Right value</th>
            <th>Tolerance</th>
          </tr>
        </thead>
        <tbody>
          {results.map((r) => (
            <ResultRow key={r.id} result={r} />
          ))}
        </tbody>
      </table>
    </section>
  );
}

function ResultRow({ result }: { result: CrossCheckResult }) {
  return (
    <tr>
      <td>
        <code>{result.rule_code}</code>
      </td>
      <td>
        <Pill tone={MATCH_STATUS_UI[result.match_status].tone}>
          {MATCH_STATUS_UI[result.match_status].label}
        </Pill>
      </td>
      <td>{TRUTH_SOURCE_UI[result.left_source_type].label}</td>
      <td>{result.right_source_type}</td>
      <td>{formatValue(result.left_value, result.normalized_left_value)}</td>
      <td>{formatValue(result.right_value, result.normalized_right_value)}</td>
      <td>{result.tolerance_used ?? "—"}</td>
    </tr>
  );
}

function formatValue(raw: string | null, normalized: string | null) {
  if (raw === null) return "—";
  if (normalized && normalized !== raw) {
    return `${raw} (→ ${normalized})`;
  }
  return raw;
}
